import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  TableLoader,
} from "../../components/commons";
import { SearchIcon } from "../../components/Icon";
import { Toaster, toast } from "react-hot-toast";
import { RootState } from "../../redux/rootReducers";
import { getAllFinacUsersAction, resetSession } from "../../redux/auth";
import { analyticsGrey, analyticsIcon } from "../../assets/images";
import LeadModuleListTable from "../../components/LeadModule/LeadModuleListTable";
import {
  addLeadCommentsAction,
  getClientDirectoryLeadListAction,
  getClientDirectoryLeadStageCountAction,
  getLeadCommentsDetailsAction,
  getSingleClientDirectoryLeadDetailsAction,
  leadClientSentEmailHistoryAction,
  leadHistoryAction,
  leadSentEmailAction,
  resetClientDirectoryError,
  resetClientDirectoryFetching,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetLeadDirectoryCommentsFetching,
  resetLeadDirectoryList,
  resetLeadDirectoryTotal,
  resetLeadEmailFetching,
  resetLeadClientEmailHistory,
  resetLeadHistory,
  resetLeadModuleCommentsListing,
  resetLeadModuleCommentsSuccess,
  resetLeadStageCount,
  resetSingleClientLeadDirectoryDetails,
  setPersistLeadDirectory,
  getLeadRecordingDetailsAction,
  resetLeadModuleRecordingsListing,
  resetLeadModuleRecordingsSuccess,
  addLeadRecordingAction,
  getCityListAction,
  resetUniqueCityList,
  resetUniqueCityCount,
  resetCityFetching,
  updateLeadStatusAction,
  getStageListAction,
  resetLeadStageList,
  getClientDirectorySortByThresholdLeadListAction,
  getClientDirectoryLeadStageSortByStageCountAction,
} from "../../redux/clientDirectory";
import useDebounce from "../../customHooks/useDebounce";
import { GetAllFinacUserPayloadType } from "../../commonTypes/authTypes";
import {
  AddLeadModuleCommentPayload,
  ChangeClientStatusChangePayloadType,
  EmailHistoryPayload,
  GetCityListPayloadType,
  GetHistoryPayload,
  GetLeadDirectoryListPayloadType,
  GetLeadModuleCommentsPayload,
  LeadModuleStageHistoryListType,
  SelectStageOptionType,
  SendEmailPayload,
  SingleClientLeadDirectoryDetails,
  StageDetailsType,
} from "../../commonTypes/clientDirectoryTypes";
import { LEAD_DIRECTORY_LIST_HEADERS } from "../../constant/tableHeadersConstants/LeadDirectoryConstants/leadDirectoryListTableHeaders";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import ProgressCommentsModal from "../../components/JobListing/ProgressCommentsModal";
import LeadModuleStageHistory from "../../components/LeadModule/LeadModuleStageHistory";
import LeadModuleListFilter from "../../components/LeadModule/LeadModuleListFilter";
import LeadListSorting from "../../components/LeadModule/LeadListSorting";
import LeadStageCount from "../../components/LeadModule/LeadStageCount";
import {
  LeadStageCountListType,
  PersistLeadDirectoryListType,
} from "../../redux/clientDirectory/clientDirectoryType";
import RightDrawer from "../../components/commons/CustomDrawer/RightDrawer";
import LeadModuleEmailModal from "../../components/LeadModule/LeadModuleEmailModal/LeadModuleEmailModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DownloadCheckInReports from "../../components/MySpace/CheckInModule/DownloadCheckInReports";
import {
  downloadLeadCommentsReportsApi,
  downloadLeadStageProgressReportsApi,
} from "../../apis/clientDirectory";
import FileSaver from "file-saver";
import moment from "moment";
import {
  ClientCategoryListType,
  ScopeOfWorkListType,
} from "../../redux/masterData/masterTypes";
import {
  GetClientCategoryPayloadType,
  GetUsersDepartmentPayloadType,
} from "../../commonTypes/masterDataTypes";
import {
  getMasterDataClientCategoryAction,
  getMasterDataScopeOfWorkAction,
} from "../../redux/masterData";
import { SelctOptionType } from "../../components/DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { Label } from "reactstrap";
import { useLocation } from "react-router-dom";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";

type DropDownOptionType = {
  value: string | null;
  label: string;
};

type FilterPersistType = {
  callFrequency: DropDownOptionType;
  filterEndDate: string;
  filterStartDate: string;
  filterStatus: string;
  leadAssignTo: DropDownOptionType;
  stage: DropDownOptionType;
  leadCategory: DropDownOptionType;
  turnOverFilter: DropDownOptionType;
  clientCategoryFilter: any;
  migrateToFinacFilter: boolean;
  scopeFilter: any;
  cityFilter: DropDownOptionType;
  leadStatusFilter: DropDownOptionType;
};
interface TabsType {
  name: string;
  label: string;
  display: boolean | undefined;
}
const tabs: TabsType[] = [
  {
    name: "Priority Lead",
    label: "priority-lead",
    display: true,
  },
  {
    name: "All Leads",
    label: "all-leads",
    display: true,
  },
];

type AppProps = {
  token: null | string;
  finacUser: any;
  history: any;
  fetching: boolean;
  statusCode: number | null;
  message: string | null;
  success: number | null;
  error: null | string;
  loginData: LoginResponseType;
  sideMenus: any[];
  commentLeadFetching: boolean;
  leadFetching: boolean;
  cityFetching: boolean;
  uniqueCityList: string[];
  uniqueCityCount: number;
  dispatchResetCityFetching: () => void;
  commentSuccess: number | null;
  leadDirectoryRecordingsSuccess: number | null;
  leadModuleCommentsList: any[];
  leadDirectoryRecordingsList: any[];
  persistLeadDirectoryList: PersistLeadDirectoryListType;
  leadStageCount: LeadStageCountListType[] | [];
  dispatchResetSession: () => void;
  dispatchResetLeadDirectoryTotal: () => void;
  dispatchResetCommentSuccess: () => void;
  leadDirectoryList: [] | any[];
  totalCount: number;
  dispatchGetLeadListDataAction: (
    data: GetLeadDirectoryListPayloadType
  ) => void;
  dispatchGetLeadSortByThresholdListDataAction: (
    data: GetLeadDirectoryListPayloadType
  ) => void;
  dispatchGetLeadStageCountAction: (
    data: GetLeadDirectoryListPayloadType
  ) => void;
  dispatchResetSuccess: () => void;
  dispatchResetError: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetLeadList: () => void;
  dispatchResetFetching: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetLeadModuleCommentsAction: (
    data: GetLeadModuleCommentsPayload
  ) => void;
  dispatchGetLeadRecordingDetailsAction: (
    data: GetLeadModuleCommentsPayload
  ) => void;
  dispatchAddLeadModuleCommentAction: (
    data: AddLeadModuleCommentPayload
  ) => void;
  dispatchAddLeadRecordingAction: (data: AddLeadModuleCommentPayload) => void;
  dispatchResetLeadCommentsListing: () => void;
  dispatchResetLeadModuleRecordingsListing: () => void;
  dispatchResetLeadCommentsSuccess: () => void;
  dispatchResetLeadModuleRecordingsSuccess: () => void;
  dispatchResetLeadDirectoryCommentsFetching: () => void;
  dispatchLeadHistory: (data: GetHistoryPayload) => void;
  dispatchGetLeadStageSortByStageCountAction: (
    data: GetLeadDirectoryListPayloadType
  ) => void;
  leadHistory: LeadModuleStageHistoryListType[];
  singleClientleadDirectoryDetails: any;
  clientCategoryTotalCount: number;
  dispatchResetLeadHistory: () => void;
  dispatchResetLeadStageCount: () => void;
  dispatchGetSingleClientDirectoryLeadDetailsAction: (
    data: SingleClientLeadDirectoryDetails
  ) => void;
  dispatchResetSingleClientLeadDirectoryDetails: () => void;
  dispatchSentEmailAction: (data: SendEmailPayload) => void;
  emailFetching: boolean;
  dispatchEmailHistoryAction: (data: EmailHistoryPayload) => void;
  leadEmailHistory: [] | any;
  clientCategoryList: ClientCategoryListType[] | [];
  dispatchResetLeadEmailHistory: () => void;
  dispatchResetLeadEmailFetching: () => void;
  dispatchSetPersistLeadDirectoryData: (data: any) => void;
  dispatchGetMasterDataClientCategoryAction: (
    data: GetClientCategoryPayloadType
  ) => void;
  scopeOfWorkList: ScopeOfWorkListType[] | [];
  leadStageData: StageDetailsType[];
  scopeOfWorkTotalCount: number;
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  dispatchGetCityListAction: (data: GetCityListPayloadType) => void;
  dispatchResetCityListAction: () => void;
  dispatchResetCityCountAction: () => void;
  dispatchLeadStatusChangeAction: (
    data: ChangeClientStatusChangePayloadType
  ) => void;
  dispatchLeadStageData: (data: GetCityListPayloadType) => void;
  dispatchResetLeadStageData: () => void;
};
const LeadModule = ({
  fetching,
  message,
  finacUser,
  history,
  success,
  error,
  token,
  statusCode,
  leadDirectoryList,
  persistLeadDirectoryList,
  loginData,
  sideMenus,
  commentLeadFetching,
  commentSuccess,
  leadDirectoryRecordingsSuccess,
  leadModuleCommentsList,
  leadDirectoryRecordingsList,
  dispatchResetFetching,
  dispatchResetCommentSuccess,
  dispatchResetCityFetching,
  totalCount,
  uniqueCityList,
  cityFetching,
  uniqueCityCount,
  leadFetching,
  leadStageCount,
  clientCategoryList,
  clientCategoryTotalCount,
  singleClientleadDirectoryDetails,
  dispatchResetSession,
  dispatchResetSuccess,
  dispatchResetError,
  dispatchResetLeadList,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchGetLeadListDataAction,
  dispatchGetLeadSortByThresholdListDataAction,
  dispatchGetLeadStageCountAction,
  dispatchResetLeadDirectoryTotal,
  dispatchGetAllFinacUsersAction,
  dispatchGetLeadModuleCommentsAction,
  dispatchGetLeadRecordingDetailsAction,
  dispatchAddLeadModuleCommentAction,
  dispatchAddLeadRecordingAction,
  dispatchResetLeadCommentsListing,
  dispatchResetLeadModuleRecordingsListing,
  dispatchResetLeadCommentsSuccess,
  dispatchResetLeadModuleRecordingsSuccess,
  dispatchResetLeadDirectoryCommentsFetching,
  dispatchLeadHistory,
  dispatchResetLeadStageCount,
  leadHistory,
  dispatchResetLeadHistory,
  dispatchGetSingleClientDirectoryLeadDetailsAction,
  dispatchResetSingleClientLeadDirectoryDetails,
  dispatchSetPersistLeadDirectoryData,
  dispatchSentEmailAction,
  emailFetching,
  dispatchEmailHistoryAction,
  leadEmailHistory,
  dispatchResetLeadEmailHistory,
  dispatchResetLeadEmailFetching,
  dispatchGetMasterDataClientCategoryAction,
  scopeOfWorkList,
  leadStageData,
  scopeOfWorkTotalCount,
  dispatchGetMasterDataScopeOfWorkAction,
  dispatchGetCityListAction,
  dispatchResetCityListAction,
  dispatchResetCityCountAction,
  dispatchLeadStatusChangeAction,
  dispatchLeadStageData,
  dispatchResetLeadStageData,
  dispatchGetLeadStageSortByStageCountAction,
}: AppProps) => {
  const sideMenu = sideMenus?.filter(
    (el: any) => el.menu_name === "Lead Module"
  );
  const persistSearchData = history?.location?.state?.searchData
    ? history?.location?.state?.searchData
    : "";
  const location = useLocation();

  const [scrollHeights, setScrollHeights] = useState<any>({});
  const [isApiCall, setIsApiCall] = useState(false);
  const [isPerist, setIsPersist] = useState(
    history?.location?.state && history?.location?.state?.isPersist
  );
  const [offset, setOffset] = useState(
    !isPerist ? 0 : +persistLeadDirectoryList?.offset
  );
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<any>(
    !isPerist
      ? []
      : persistLeadDirectoryList?.data?.length > 0
      ? [...persistLeadDirectoryList?.data]
      : []
  );
  const [searchData, setSearchData] = useState(persistSearchData || "");
  const [toggleSort, setToggleSort] = useState<boolean>(false);
  const [sortByLeadReceivedOn, setSortByLeadReceivedOn] = useState({
    name: "",
    value: "",
  });
  const [sortByStage, setSortByStage] = useState({ name: "", value: "" });
  const [sortByComment, setSortByComment] = useState({ name: "", value: "" });
  const [recently, setRecently] = useState({ name: "", value: "" });
  const [clearSearch, setClearSearch] = useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [showLeadCommentsModal, setShowLeadCommentsModal] =
    useState<boolean>(false);
  const [leadComment, setLeadComments] = useState<any[] | []>([]);
  const [leadData, setLeadData] = useState<any | null>(null);

  const [text, setText] = useState<string>("");
  const [filterStatus, setStatus] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [persistFilterStartDate, setPersistFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [migrateToFinacFilter, setMigrateToFinacFilter] =
    useState<boolean>(false);
  const [persistFilterEndDate, setPersistFilterEndDate] = useState("");
  const [stageText, setStageText] = useState<string>("");
  const [stageLimit, setStageLimit] = useState<number>(20);
  const [stageOffset, setStageOffset] = useState<number>(0);
  const [stage, setStage] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [leadCategory, setLeadCategory] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [leadStatusFilter, setLeadStatusFilter] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [persistStage, setPersistStage] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [callFrequency, setCallFrequency] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [persistCallFrequency, setPersistCallFrequency] =
    useState<DropDownOptionType>({
      value: null,
      label: "Select..",
    });
  const [leadAssignTo, setLeadAssignTo] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [turnOverFilter, setTurnOverFilter] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [persistLeadAssignTo, setPersistLeadAssignTo] =
    useState<DropDownOptionType>({
      value: null,
      label: "Select..",
    });
  const [showIsLeadSendEmail, setShowIsLeadSendEmail] = useState(false);
  const [showIsLeadSendEmailData, setShowIsLeadSendEmailData] =
    useState<any>(null);
  const [isEmailError, setIsEmailError] = useState<string>("");
  const [leadEmailText, setLeadEmailText] = useState("");
  const [cityOffset, setCityOffset] = useState(0);
  const [citySearchTerm, setCitySearchTerm] = useState("");
  const [cityFilter, setCityFilter] = useState<DropDownOptionType>({
    label: "Select..",
    value: null,
  });
  //show history
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [storeHistoryData, setStoreHistoryData] = useState<null | any>(null);
  const [commentState, setCommentState] = useState<boolean>(false);
  const persistFilterData = history?.location?.state?.filterData;
  const persistSortByLeadReceivedOn =
    history?.location?.state?.sortByLeadReceivedOn;
  const persistSortByStage = history?.location?.state?.sortByStage;
  const persistSortByComment = history?.location?.state?.sortByComment;
  const [isPieChartVisible, setIsPieChartVisible] = useState<boolean>(true);
  //  View Edit
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState<any>(null);
  const [clientCode, setClientCode] = useState(null);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [finalCategoryFilterList, setFinalCategoryFilterList] = useState<any>(
    []
  );
  const [finalCityFilterOptions, setFinalCityFilterOptions] = useState<any>([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [leadStatus, setLeadStatus] = useState<any>(null);
  const [categoryOffset, setCategoryOffset] = useState<number>(0);
  const [categoryText, setCategoryText] = useState("");
  const [clientCategoryFilter, setClientCategoryFilter] =
    useState<SelctOptionType>({
      value: null,
      label: "Select..",
    });
  //
  const [finalScopeFilterList, setFinalScopeFilterList] = useState<any>([]);
  const [scopeOffset, setScopeOffset] = useState<number>(0);
  const [scopeText, setScopeText] = useState("");
  const [stageDropDown, setStageDropDown] = useState<SelectStageOptionType[]>(
    []
  );
  const [scopeFilter, setScopeFilter] = useState<SelctOptionType>({
    value: null,
    label: "Select..",
  });
  //
  const [handlestate, setHandleState] = useState();
  const [multiSelectData, setMultiSelectData] = useState<any>({
    filterStatus: "",
    filterStartDate: "",
    filterEndDate: "",
    stage: "",
    leadCategory: "",
    callFrequency: "",
    leadAssignTo: "",
    turnOverFilter: "",
    migrateToFinacFilter: false,
    clientCategory: {
      value: null,
      label: "Select...",
    },
    scopeofWork: {
      value: null,
      label: "Select..",
    },
    city: {
      value: null,
      label: "Select..",
    },
    leadStatusFilter: "",
  });
  const categoryLimit = 20;
  const urlSearch = new URLSearchParams(location.search)?.get("tab");
  const [downloadType, setDownloadType] = useState<string>("comment");
  //====================User Management=============================
  const [isEditClientLeadDetailsPresent, setIsEditClientLeadDetailsPresent] =
    useMenuCheck();

  const [isEmailLeadDetailsPresent, setIsEmailLeadDetailsPresent] =
    useMenuCheck();
  const [isLeadListPresent, setIsLeadListPresent] = useMenuCheck();
  const [activeTab, setActiveTab] = useState<string | undefined>(tabs[0].label);
  const [isLeadCommentListPresent, setIsLeadCommentListPresent] =
    useMenuCheck();
  const [isLeadModuleStageCountPresent, setIsLeadModuleStageCountPresent] =
    useMenuCheck();
  const [
    isLeadCommentsReportsDownloadPresent,
    setIsLeadCommentsReportsDownloadPresent,
  ] = useMenuCheck();
  const [isLeadStatusPresent, setIsLeadStatusPresent] = useMenuCheck();
  //=================================================================
  useEffect(() => {
    setIsLeadStatusPresent("Lead Status", "menu");
    if (!isPerist) {
      window.scroll({
        top: 0,
        left: 0,
      });

      setOffset(0);

      dispatchResetCityCountAction();
      dispatchResetCityFetching();
      dispatchResetCityListAction();
      dispatchResetLeadDirectoryTotal();
      dispatchResetSuccess();
      dispatchResetLeadCommentsSuccess();
      dispatchResetLeadModuleRecordingsSuccess();
      dispatchResetError();
      dispatchResetMessage();
      dispatchResetStatusCode();
      dispatchResetLeadList();
      dispatchResetLeadStageCount();
      dispatchResetLeadDirectoryCommentsFetching();
      setIsEditClientLeadDetailsPresent("Edit Lead Module", "menu");
      setIsEmailLeadDetailsPresent("Send Lead Email", "menu");
      setIsLeadListPresent("Lead Module List", "menu");
      setIsLeadCommentListPresent("Lead Module Comments List", "menu");
      setIsLeadModuleStageCountPresent("Lead Module Stage Count", "menu");

      setIsLeadCommentsReportsDownloadPresent(
        "Download Lead Comments Reports",
        "menu"
      );
      dispatchResetLeadHistory();
      dispatchResetSingleClientLeadDirectoryDetails();
      dispatchResetLeadEmailHistory();
      dispatchResetLeadEmailFetching();
      dispatchResetLeadStageData();
      if (token) {
        dispatchLeadStageData({ token });
      }
    } else {
      window.scroll({
        top: persistLeadDirectoryList?.scrollTop,
        left: persistLeadDirectoryList?.scrollLeft,
      });
    }
  }, []);

  useEffect(() => {
    let params = urlSearch || history?.location?.state?.tab;

    if (!params) {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("tab", "priority-lead");

      history.replace(`?${searchParams.toString()}`);

      params = "priority-lead";
    }

    setActiveTab(params);
  }, [location.search, history]);

  useEffect(() => {
    if (activeTab) {
      fetchLeadData(activeTab);
    }
  }, [activeTab]);

  useEffect(() => {
    const finalCategoryData = clientCategoryList?.map((user: any) => {
      return {
        value: user?._id,
        label: user?.name_of_category,
      };
    });
    if (categoryOffset > 0) {
      setFinalCategoryFilterList([
        ...finalCategoryFilterList,
        ...finalCategoryData,
      ]);
    } else {
      setFinalCategoryFilterList(finalCategoryData);
    }
  }, [clientCategoryList]);

  useEffect(() => {
    if (leadStageData?.length > 0) {
      let finalData = leadStageData?.map((item: StageDetailsType) => {
        return {
          label: item?.stage_name,
          value: item?._id,
        };
      });
      setStageDropDown([...finalData]);
    }
  }, [leadStageData]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
    setIsPersist(false);
    setOffset(0);
    history.replace({
      pathname: location.pathname,
      search: `?tab=${tabs}`,
      state: {},
    });
    clearFilter();
    setShowHistoryModal(false);
    setIsPieChartVisible(true);
    setSearchData("");
    handleResetData();
    handleClearFilterStates();
    setSortByLeadReceivedOn({
      name: "",
      value: "",
    });
  };

  const renderTabs = () => {
    let finalTab = tabs.map((tab: TabsType) => {
      return (
        <div
          className={tab.display ? "tab-style mr-4" : ""}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          {tab.display && (
            <div
              style={{
                padding: "12px 5px 12px 5px",
                color: activeTab === tab.label ? "#dd4433" : "",
                fontSize: "14px",
              }}
              className={`tab-header ${
                activeTab === tab.label ? "active" : ""
              }`}
            >
              {tab.name}
            </div>
          )}
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };

  useEffect(() => {
    if (uniqueCityList?.length > 0) {
      if (cityOffset <= uniqueCityCount) {
        const finalCityList = uniqueCityList
          ?.filter((item) => item?.length > 0)
          ?.map((city: any) => {
            return {
              value: city,
              label: city,
            };
          });
        if (cityOffset > 0) {
          setFinalCityFilterOptions([
            ...finalCityFilterOptions,
            ...finalCityList,
          ]);
        } else {
          setFinalCityFilterOptions([...finalCityList]);
        }
      }
    }
  }, [uniqueCityList]);

  //
  useEffect(() => {
    const finalScopeOfWorkData = scopeOfWorkList?.map((scope: any) => {
      return {
        value: scope?._id,
        label: scope?.scope_of_work_name,
      };
    });
    if (scopeOffset > 0) {
      setFinalScopeFilterList([
        ...finalScopeFilterList,
        ...finalScopeOfWorkData,
      ]);
    } else {
      setFinalScopeFilterList(finalScopeOfWorkData);
    }
  }, [scopeOfWorkList]);

  const fetchLeadData = (tab: string | undefined) => {
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetStatusCode();

    if (token) {
      let finalData: any = {
        token,
        limit,
        offset,
        searchData,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: stage?.value ? stage : persistFilterData?.stage,
        leadCategory: leadCategory?.value
          ? leadCategory
          : persistFilterData?.leadCategory,
        callFrequency: callFrequency?.value
          ? callFrequency
          : persistFilterData?.callFrequency,
        leadAssignTo: leadAssignTo?.value
          ? leadAssignTo
          : persistFilterData?.leadAssignTo,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : persistFilterData?.turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,
        leadStatusFilter: leadStatusFilter
          ? leadStatusFilter
          : persistFilterData?.leadStatusFilter,
        clientCategory:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter?.value
            : persistFilterData?.cityFilter?.value,
      };
      tab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent &&
          (tab === "priority-lead"
            ? dispatchGetLeadStageSortByStageCountAction(finalData)
            : dispatchGetLeadStageCountAction(finalData));
      }
    }
  };

  const clearFilter = () => {
    setStatus("");
    setFilterEndDate("");
    setFilterStartDate("");
    setMigrateToFinacFilter(false);
    setStage({
      value: null,
      label: "Select..",
    });
    setLeadAssignTo({
      value: null,
      label: "Select..",
    });
    setLeadCategory({
      value: null,
      label: "Select..",
    });
    setClientCategoryFilter({
      value: null,
      label: "Select..",
    });
    setTurnOverFilter({
      value: null,
      label: "Select..",
    });
  };

  useEffect(() => {
    if (!isPerist) {
      fetchLeadData(activeTab);
    }
    if (persistFilterData) {
      const {
        callFrequency,
        filterEndDate,
        filterStartDate,
        filterStatus,
        leadAssignTo,
        stage,
        leadCategory,
        turnOverFilter,
        clientCategoryFilter,
        scopeFilter,
        cityFilter,
        leadStatusFilter,
      }: FilterPersistType = persistFilterData;
      setCallFrequency({
        ...callFrequency,
      });
      setPersistCallFrequency({
        ...callFrequency,
      });
      setStage({
        ...stage,
      });
      setClientCategoryFilter({
        ...clientCategoryFilter,
      });
      setScopeFilter({
        ...scopeFilter,
      });
      setCityFilter(
        cityFilter
          ? {
              ...cityFilter,
            }
          : {
              label: "Select..",
              value: null,
            }
      );
      setMigrateToFinacFilter(
        persistFilterData?.migrateToFinacFilter ? true : false
      );
      setLeadCategory({
        ...leadCategory,
      });
      setLeadStatusFilter({
        ...leadStatusFilter,
      });
      setTurnOverFilter({
        ...turnOverFilter,
      });
      setPersistStage({
        ...stage,
      });
      setLeadAssignTo({
        ...leadAssignTo,
      });
      setPersistLeadAssignTo({
        ...leadAssignTo,
      });
      setFilterStartDate(filterStartDate);
      setFilterEndDate(filterEndDate);
      setStatus(filterStatus);
    }
    if (persistSortByLeadReceivedOn?.name || persistSortByStage?.name) {
      setSortByLeadReceivedOn({ ...persistSortByLeadReceivedOn });
      setSortByStage({ ...persistSortByStage });
    }
  }, [activeTab]);

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name} ${user?.last_name}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (stageOffset > 0 && finalUserList?.length) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    if (persistLeadDirectoryList?.data?.length > 0) {
      setIsApiCall(true);
      setScrollHeights({
        scrollLeft: persistLeadDirectoryList?.scrollLeft,
        scrollTop: persistLeadDirectoryList?.scrollTop,
      });
    }
  }, [persistLeadDirectoryList?.data]);

  useEffect(() => {
    setMultiSelectData((prev: any) => {
      return {
        filterStatus: filterStatus ? filterStatus : "",
        filterStartDate: filterStartDate ? filterStartDate : "",
        filterEndDate: filterEndDate ? filterEndDate : "",
        stage: stage?.value ? stage : { value: "", label: "Select.." },
        leadCategory: leadCategory?.value
          ? leadCategory
          : { value: "", label: "Select.." },
        leadStatusFilter:
          leadStatusFilter?.value?.toString() === "0" || leadStatusFilter?.value
            ? leadStatusFilter
            : { value: "", label: "Select.." },
        callFrequency: callFrequency?.value
          ? callFrequency
          : { value: "", label: "Select.." },
        leadAssignTo: leadAssignTo?.value
          ? leadAssignTo
          : { value: "", label: "Select.." },
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : { value: "", label: "Select.." },
        migrateToFinacFilter: migrateToFinacFilter
          ? true
          : persistFilterData?.migrateToFinacFilter
          ? true
          : false,

        clientCategoryFilter:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter?.value
            ? persistFilterData?.clientCategoryFilter
            : { value: null, label: "Select.." },
        scopeFilter: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter?.value
          ? persistFilterData?.scopeFilter
          : { value: null, label: "Select.." },
        cityFilter:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter
            : persistFilterData?.cityFilter?.value
            ? persistFilterData?.cityFilter
            : { value: null, label: "Select.." },
      };
    });
  }, [leadDirectoryList]);
  useEffect(() => {
    if (!isPerist) {
      if (leadDirectoryList?.length === 0) {
        setData(leadDirectoryList);
      } else if (offset > 0 && leadDirectoryList?.length > 0 && !fetching) {
        setData((prv: any) => [...prv, ...leadDirectoryList]);
      } else {
        setData(leadDirectoryList);
      }
    }
  }, [leadDirectoryList]);

  useEffect(() => {
    if (showIsLeadSendEmailData?.to_email) {
      setLeadEmailText(showIsLeadSendEmailData?.to_email);
    } else {
      setLeadEmailText("");
    }
  }, [showIsLeadSendEmailData?.to_email, showIsLeadSendEmail]);

  useEffect(() => {
    let finalData: any = {
      token,
      limit,
      offset,
      searchData,
      sortByLeadReceivedOn: sortByLeadReceivedOn?.name
        ? sortByLeadReceivedOn
        : persistSortByLeadReceivedOn,
      sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
      sortByComment: sortByComment?.name ? sortByComment : persistSortByComment,
      stage: stage?.value ? stage : persistFilterData?.stage,
      leadCategory: leadCategory?.value
        ? leadCategory
        : persistFilterData?.leadCategory,
      leadStatusFilter: leadStatusFilter?.value
        ? leadStatusFilter
        : persistFilterData?.leadStatusFilter,
      callFrequency: callFrequency?.value
        ? callFrequency
        : persistFilterData?.callFrequency,
      leadAssignTo: leadAssignTo?.value
        ? leadAssignTo
        : persistFilterData?.leadAssignTo,
      filterStartDate: filterStartDate
        ? filterStartDate
        : persistFilterData?.filterStartDate,
      filterEndDate: filterEndDate
        ? filterEndDate
        : persistFilterData?.filterEndDate,
      role:
        loginData?.group_id === 1 || loginData?.group_id === 285
          ? "admin"
          : "user",
      turnOverFilter: turnOverFilter?.value
        ? turnOverFilter
        : persistFilterData?.turnOverFilter,
      migrateToFinacFilter: migrateToFinacFilter
        ? migrateToFinacFilter
        : persistFilterData?.migrateToFinacFilter,

      clientCategory:
        clientCategoryFilter?.label === "Select..."
          ? ""
          : clientCategoryFilter?.value
          ? clientCategoryFilter
          : persistFilterData?.clientCategoryFilter,
      scopeofWork: scopeFilter?.value
        ? scopeFilter
        : persistFilterData?.scopeFilter,
      city:
        cityFilter?.label === "Select..."
          ? ""
          : cityFilter?.value
          ? cityFilter?.value
          : persistFilterData?.cityFilter?.value,
    };
    if (offset > 0) {
      dispatchResetError();
      dispatchResetSuccess();
      dispatchResetMessage();
      dispatchResetStatusCode();
      if (token) {
        if ((isPerist && isApiCall) || !isPerist) {
          if (totalCount) {
            if (offset < totalCount) {
              setIsPersist(false);
              activeTab === "priority-lead"
                ? dispatchGetLeadSortByThresholdListDataAction(finalData)
                : dispatchGetLeadListDataAction(finalData);
              {
                isLeadModuleStageCountPresent && activeTab === "priority-lead"
                  ? dispatchGetLeadStageSortByStageCountAction(finalData)
                  : dispatchGetLeadStageCountAction(finalData);
              }
            }
          } else {
            setIsPersist(false);
            activeTab === "priority-lead"
              ? dispatchGetLeadSortByThresholdListDataAction(finalData)
              : dispatchGetLeadListDataAction(finalData);
            {
              isLeadModuleStageCountPresent && activeTab === "priority-lead"
                ? dispatchGetLeadStageSortByStageCountAction(finalData)
                : dispatchGetLeadStageCountAction(finalData);
            }
          }
        }
      }
    }
  }, [offset, isLeadModuleStageCountPresent]);

  //Lead dropdown
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: stageOffset,
        limit: stageLimit,
        user_type: "stco_users",
        status: 1,
        search_term: stageText,
      };
      if (stageOffset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [stageOffset]);

  const fetchNewLeadData = (search: string) => {
    const finalData = {
      token,
      offset: stageOffset,
      limit: stageLimit,
      user_type: "stco_users",
      status: 1,
      search_term: stageText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  const handleCityFilterChange = (e: any) => {
    setCityFilter({
      value: e?.value ? e?.value : null,
      label: e?.label ? e?.label : "Select..",
    });
  };

  const handleShowConfirmationModal = () => {
    setShowConfirmationModal((prev) => !prev);
  };

  useDebounce(
    () => {
      if (stageText) {
        fetchNewLeadData(stageText);
      } else {
        const finalData = {
          token,
          offset: stageOffset,
          limit: stageLimit,
          user_type: "stco_users",
          status: 1,
          search_term: stageText,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [stageText]
  );

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        limit: categoryLimit,
        offset: categoryOffset,
        search_term: categoryText,
        status: 1,
      };
      if (categoryOffset <= clientCategoryTotalCount) {
        dispatchGetMasterDataClientCategoryAction(finalUserData);
      } else {
        dispatchGetMasterDataClientCategoryAction(finalUserData);
      }
    }
  }, [categoryOffset]);

  useEffect(() => {
    if (token) {
      // dispatchResetCityCountAction()
      // dispatchResetCityListAction()

      let finalData = {
        token,
        limit: categoryLimit,
        offset: cityOffset,
        searchTerm: citySearchTerm,
      };
      if (cityOffset <= uniqueCityCount) {
        dispatchGetCityListAction(finalData);
      } else {
        dispatchGetCityListAction(finalData);
      }
    }
  }, [cityOffset]);

  //
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        limit: limit,
        offset: scopeOffset,
        searchValue: scopeText,
        status: 1,
      };
      if (scopeOffset <= scopeOfWorkTotalCount) {
        dispatchGetMasterDataScopeOfWorkAction(finalUserData);
      }
    }
  }, [scopeOffset]);

  const fetchScopeOfWorkData = (search: string) => {
    const finalData = {
      token,
      limit: limit,
      offset: scopeOffset,
      searchValue: scopeText,
      status: 1,
    };
    dispatchGetMasterDataScopeOfWorkAction(finalData);
  };
  useDebounce(
    () => {
      if (scopeText) {
        fetchScopeOfWorkData(scopeText);
      } else {
        const finalData = {
          token,
          limit: limit,
          offset: scopeOffset,
          searchValue: scopeText,
          status: 1,
        };
        dispatchGetMasterDataScopeOfWorkAction(finalData);
      }
    },
    500,
    [scopeText]
  );
  const fetchNewCategoryData = (search: string) => {
    const finalData = {
      token,
      limit: categoryLimit,
      offset: categoryOffset,
      search_term: categoryText,
      status: 1,
    };
    dispatchGetMasterDataClientCategoryAction(finalData);
  };

  useDebounce(
    () => {
      if (categoryText) {
        fetchNewCategoryData(categoryText);
      } else {
        const finalData = {
          token,
          limit: categoryLimit,
          offset: categoryOffset,
          search_term: categoryText,
          status: 1,
        };
        dispatchGetMasterDataClientCategoryAction(finalData);
      }
    },
    500,
    [categoryText]
  );

  const fetchNewCityData = (search: string) => {
    dispatchResetCityCountAction();
    dispatchResetCityListAction();
    let finalData = {
      token,
      limit: categoryLimit,
      offset: cityOffset,
      searchTerm: citySearchTerm,
    };
    dispatchGetCityListAction(finalData);
  };

  useDebounce(
    () => {
      if (citySearchTerm) {
        fetchNewCityData(citySearchTerm);
      } else {
        dispatchResetCityCountAction();
        dispatchResetCityListAction();
        let finalData = {
          token,
          limit: categoryLimit,
          offset: cityOffset,
          searchTerm: citySearchTerm,
        };
        dispatchGetCityListAction(finalData);
      }
    },
    500,
    [citySearchTerm]
  );

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        if (!isPerist) {
          setOffset(0);
        }
        fetchNewData();
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchData, persistSearchData]);

  useEffect(() => {
    if (
      token &&
      (sortByStage?.name ||
        sortByLeadReceivedOn?.name ||
        recently?.name ||
        sortByComment?.name)
    ) {
      dispatchResetError();
      dispatchResetSuccess();
      dispatchResetLeadList();
      dispatchResetLeadStageCount();
      dispatchResetMessage();
      dispatchResetStatusCode();
      dispatchResetLeadDirectoryTotal();
      if (!isPerist) {
        setOffset(0);
      }
      let finalData: any = {
        token,
        limit,
        offset,
        searchData,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: stage?.value ? stage : persistFilterData?.stage,
        leadCategory: leadCategory?.value
          ? leadCategory
          : persistFilterData?.leadCategory,
        leadStatusFilter: leadStatusFilter?.value
          ? leadStatusFilter
          : persistFilterData?.leadStatusFilter,
        callFrequency: callFrequency?.value
          ? callFrequency
          : persistFilterData?.callFrequency,
        leadAssignTo: leadAssignTo?.value
          ? leadAssignTo
          : persistFilterData?.leadAssignTo,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : persistFilterData?.turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,

        clientCategory:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter?.value
            : persistFilterData?.cityFilter?.value,
      };
      activeTab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent && activeTab === "priority-lead"
          ? dispatchGetLeadStageSortByStageCountAction(finalData)
          : dispatchGetLeadStageCountAction(finalData);
      }
    }
  }, [sortByStage, sortByLeadReceivedOn, recently, sortByComment]);

  useEffect(() => {
    if (showHistoryModal && storeHistoryData) {
      dispatchLeadHistory({
        token,
        client_code: storeHistoryData.client_code,
      });
    } else {
      dispatchResetLeadHistory();
      setStoreHistoryData(null);
    }
  }, [showHistoryModal]);

  useEffect(() => {
    if (
      token &&
      (persistFilterData?.stage?.value ||
        persistFilterData?.leadCategory?.value ||
        persistFilterData?.leadStatusFilter?.value ||
        persistFilterData?.callFrequency?.value ||
        persistFilterData?.leadAssignTo?.value ||
        persistFilterData?.filterStartDate ||
        persistFilterData?.turnOverFilter?.value ||
        persistFilterData?.filterEndDate)
    ) {
      dispatchResetError();
      dispatchResetSuccess();
      dispatchResetLeadList();
      dispatchResetLeadStageCount();
      dispatchResetMessage();
      dispatchResetStatusCode();
      dispatchResetLeadDirectoryTotal();
      if (!isPerist) {
        setOffset(0);
      }
      let finalData: any = {
        token,
        limit,
        offset,
        searchData,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: persistFilterData?.stage,
        leadCategory: persistFilterData?.leadCategory,
        leadStatusFilter: persistFilterData?.leadStatusFilter,
        callFrequency: persistFilterData?.callFrequency,
        leadAssignTo: persistFilterData?.leadAssignTo,
        filterStartDate: persistFilterData?.filterStartDate,
        filterEndDate: persistFilterData?.filterEndDate,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : persistFilterData?.turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,

        clientCategory:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter?.value
            : persistFilterData?.cityFilter?.value,
      };
      activeTab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent && activeTab === "priority-lead"
          ? dispatchGetLeadStageSortByStageCountAction(finalData)
          : dispatchGetLeadStageCountAction(finalData);
      }
    }
  }, [
    persistFilterData?.stage?.value,
    persistFilterData?.leadCategory?.value,
    persistFilterData?.leadStatusFilter?.value,
    persistFilterData?.callFrequency?.value,
    persistFilterData?.leadAssignTo?.value,
    persistFilterData?.filterStartDate,
    persistFilterData?.filterEndDate,
    persistFilterData?.turnOverFilter?.value,
    persistFilterData?.cityFilter?.value,
  ]);

  useDebounce(
    () => {
      if (searchData) {
        fetchNewData();
      }
    },
    500,
    [searchData]
  );

  const fetchNewData = () => {
    if (token) {
      if (isPerist && searchData === persistLeadDirectoryList?.searchData)
        return;
      setClearSearch(true);
      let finalData = {
        token,
        searchData,
        limit,
        offset: 0,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: stage?.value ? stage : persistFilterData?.stage,
        leadCategory: leadCategory?.value
          ? leadCategory
          : persistFilterData?.leadCategory,
        leadStatusFilter: leadStatusFilter?.value
          ? leadStatusFilter
          : persistFilterData?.leadStatusFilter,
        callFrequency: callFrequency?.value
          ? callFrequency
          : persistFilterData?.callFrequency,
        leadAssignTo: leadAssignTo?.value
          ? leadAssignTo
          : persistFilterData?.leadAssignTo,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : persistFilterData?.turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,

        clientCategory:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter?.value
            : persistFilterData?.cityFilter?.value,
      };
      activeTab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent && activeTab === "priority-lead"
          ? dispatchGetLeadStageSortByStageCountAction(finalData)
          : dispatchGetLeadStageCountAction(finalData);
      }
      setOffset(0);
    }
  };
  const handleResetData = () => {
    setIsPersist(false);
    dispatchResetError();
    dispatchResetSuccess();
    dispatchSetPersistLeadDirectoryData({
      data: [],
      offset: 0,
      scrollLeft: null,
      scrollTop: null,
      searchData: "",
    });
    dispatchResetLeadList();
    dispatchResetLeadStageCount();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetLeadDirectoryTotal();
    setOffset(0);
  };

  const handleRefresh = () => {
    handleResetData();
    if (token) {
      let finalData = {
        token,
        searchData,
        limit,
        offset: 0,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: stage,
        leadCategory: leadCategory,
        leadStatusFilter: leadStatusFilter,
        callFrequency: callFrequency,
        leadAssignTo: leadAssignTo,
        filterStartDate: filterStartDate,
        filterEndDate: filterEndDate,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : persistFilterData?.turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,

        clientCategory:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter?.value
            : persistFilterData?.cityFilter?.value,
      };
      activeTab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent && activeTab === "priority-lead"
          ? dispatchGetLeadStageSortByStageCountAction(finalData)
          : dispatchGetLeadStageCountAction(finalData);
      }
    }
  };

  const handleApplyFilter = () => {
    delete history?.location?.state?.filterData?.scopeFilter;
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetLeadList();
    dispatchResetLeadStageCount();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetLeadDirectoryTotal();
    if (
      filterStatus ||
      filterStartDate ||
      filterEndDate ||
      stage?.value ||
      leadCategory?.value ||
      callFrequency?.value ||
      leadAssignTo?.value ||
      turnOverFilter?.value ||
      clientCategoryFilter?.value ||
      migrateToFinacFilter ||
      scopeFilter?.value ||
      cityFilter?.value ||
      cityFilter?.label === "Select..." ||
      leadStatusFilter?.value
    ) {
      setMultiSelectData([
        filterStartDate,
        filterStatus,
        filterEndDate,
        stage,
        leadCategory,
        callFrequency,
        leadAssignTo,
        turnOverFilter,
        migrateToFinacFilter,
        clientCategoryFilter,
        scopeFilter,
        cityFilter,
        leadStatusFilter,
      ]);
    }
    handleResetData();
    setOffset(0);
    if (token) {
      let finalData = {
        token,
        searchData,
        limit,
        offset: 0,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: stage,
        leadCategory: leadCategory,
        leadStatusFilter: leadStatusFilter,
        callFrequency: callFrequency,
        leadAssignTo: leadAssignTo,
        filterStartDate: filterStartDate,
        filterEndDate: filterEndDate,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,

        clientCategory:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter?.value
            : persistFilterData?.cityFilter?.value,
      };
      activeTab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent && activeTab === "priority-lead"
          ? dispatchGetLeadStageSortByStageCountAction(finalData)
          : dispatchGetLeadStageCountAction(finalData);
      }
    }
  };

  useEffect(() => {
    if (leadModuleCommentsList) {
      setLeadComments(leadModuleCommentsList);
    }
  }, [leadModuleCommentsList]);

  const handleToggleLeadCommentsModal = () => {
    setShowLeadCommentsModal(!showLeadCommentsModal);

    if (commentState && offset === 0) {
      let finalData: any = {
        token,
        limit,
        offset,
        searchData,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: stage?.value ? stage : persistFilterData?.stage,
        leadCategory: leadCategory?.value
          ? leadCategory
          : persistFilterData?.leadCategory,
        leadStatusFilter: leadStatusFilter?.value
          ? leadStatusFilter
          : persistFilterData?.leadStatusFilter,
        callFrequency: callFrequency?.value
          ? callFrequency
          : persistFilterData?.callFrequency,
        leadAssignTo: leadAssignTo?.value
          ? leadAssignTo
          : persistFilterData?.leadAssignTo,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : persistFilterData?.turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,

        clientCategory:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter?.value
            : persistFilterData?.cityFilter?.value,
      };
      activeTab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent && activeTab === "priority-lead"
          ? dispatchGetLeadStageSortByStageCountAction(finalData)
          : dispatchGetLeadStageCountAction(finalData);
      }
    }
  };
  const handleSetLeadData = (data: any) => {
    dispatchResetLeadCommentsListing();
    dispatchResetLeadModuleRecordingsListing();
    setLeadComments([]);
    setLeadData(data);
    let finalData: GetLeadModuleCommentsPayload = {
      client_code: data?.client_code,
      token,
    };
    dispatchGetLeadModuleCommentsAction(finalData);
    dispatchGetLeadRecordingDetailsAction(finalData);
  };

  const handleSubmitLeadComment = (data: any) => {
    setCommentState(true);
    let finalData: AddLeadModuleCommentPayload = {
      client_code: leadData?.client_code,
      comment: data?.commentText,
      token,
    };
    dispatchAddLeadModuleCommentAction(finalData);
  };

  const handleClientCategoryChange = (e: any) => {
    setClientCategoryFilter({
      value: e?.value ? e?.value : null,
      label: e?.label ? e?.label : "Select...",
    });
  };
  const handleScopeChange = (e: any) => {
    setScopeFilter({
      value: e?.value ? e?.value : null,
      label: e?.label ? e?.label : "Select...",
    });
  };

  const handleSubmitLeadRecording = (data: any) => {
    setCommentState(true);
    let finalData: AddLeadModuleCommentPayload = {
      client_code: leadData?.client_code,
      recording_url: data?.linkData,
      token,
    };

    dispatchAddLeadRecordingAction(finalData);
  };

  const handleClearFilterStates = () => {
    delete history?.location?.state?.filterData;
    setMultiSelectData([]);
    setCallFrequency({
      value: null,
      label: "Select..",
    });
    setLeadCategory({
      value: null,
      label: "Select..",
    });
    setLeadStatusFilter({
      value: null,
      label: "Select..",
    });
    setTurnOverFilter({
      value: null,
      label: "Select..",
    });
    setStage({
      value: null,
      label: "Select..",
    });
    setScopeFilter({
      value: null,
      label: "Select..",
    });
    setCityFilter({
      value: null,
      label: "Select..",
    });
    setMigrateToFinacFilter(false);
  };

  const handleFilterClear = () => {
    handleClearFilterStates();
    dispatchResetLeadList();
    dispatchResetLeadStageCount();

    if (token) {
      let finalData = {
        token,
        searchData,
        limit,
        offset: 0,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
      };
      activeTab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent && activeTab === "priority-lead"
          ? dispatchGetLeadStageSortByStageCountAction(finalData)
          : dispatchGetLeadStageCountAction(finalData);
      }
    }
  };
  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
    if (value?.length === 0) {
      if (isPerist) {
        handleResetData();
      }
      let finalData = {
        offset: 0,
        limit,
        token,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: stage?.value ? stage : persistFilterData?.stage,
        leadCategory: leadCategory?.value
          ? leadCategory
          : persistFilterData?.leadCategory,
        leadStatusFilter: leadStatusFilter?.value
          ? leadStatusFilter
          : persistFilterData?.leadStatusFilter,
        callFrequency: callFrequency?.value
          ? callFrequency
          : persistFilterData?.callFrequency,
        leadAssignTo: leadAssignTo?.value
          ? leadAssignTo
          : persistFilterData?.leadAssignTo,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : persistFilterData?.turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,

        clientCategory:
          clientCategoryFilter?.label === "Select..."
            ? ""
            : clientCategoryFilter?.value
            ? clientCategoryFilter
            : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city:
          cityFilter?.label === "Select..."
            ? ""
            : cityFilter?.value
            ? cityFilter?.value
            : persistFilterData?.cityFilter?.value,
      };
      activeTab === "priority-lead"
        ? dispatchGetLeadSortByThresholdListDataAction(finalData)
        : dispatchGetLeadListDataAction(finalData);
      {
        isLeadModuleStageCountPresent && activeTab === "priority-lead"
          ? dispatchGetLeadStageSortByStageCountAction(finalData)
          : dispatchGetLeadStageCountAction(finalData);
      }
    }
  };

  const handleLeadStatusApiCall = () => {
    if (token) {
      const finalData = {
        token,
        clientCode: leadStatus?.client_code,
        status: !leadStatus?.status ? 1 : 0,
      };

      setData((prev: any) => {
        let newData = prev?.map((item: any) => {
          if (item?.client_code === leadStatus?.client_code) {
            return { ...item, status: !leadStatus?.status };
          } else {
            return item;
          }
        });
        return [...newData];
      });
      dispatchLeadStatusChangeAction(finalData);
    }
  };

  const handleChangeLeadStatus = (data: any) => {
    setLeadStatus(data);
    handleShowConfirmationModal();
  };

  const handleSorting = (data: any) => {
    delete history?.location?.state?.sortByLeadReceivedOn;
    delete history?.location?.state?.sortByStage;
    delete history?.location?.state?.sortByComment;
    if (!isPerist) {
      setOffset(0);
    }
    if (
      data?.name === "Lead Received on - Ascending" ||
      data?.name === "Lead Received on - Descending"
    ) {
      setSortByLeadReceivedOn(data);
      setSortByStage({ name: "", value: "" });
      setRecently({ name: "", value: "" });
      setSortByComment({ name: "", value: "" });
    } else if (
      data?.name === "Stage - Ascending" ||
      data?.name === "Stage - Descending"
    ) {
      setSortByStage(data);
      setSortByLeadReceivedOn({ name: "", value: "" });
      setRecently({ name: "", value: "" });
      setSortByComment({ name: "", value: "" });
    } else if (
      data?.name === "Comments - Ascending" ||
      data?.name === "Comments - Descending"
    ) {
      setSortByComment(data);
      setSortByStage({ name: "", value: "" });
      setSortByLeadReceivedOn({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else {
      setRecently(data);
      setSortByLeadReceivedOn({ name: "", value: "" });
      setSortByStage({ name: "", value: "" });
      setSortByComment({ name: "", value: "" });
    }
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const scrollLeft = document.documentElement.scrollLeft;
      setScrollHeights((prev: any) => ({ ...prev, scrollTop, scrollLeft }));
      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (leadDirectoryList?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };
  const handleEditLeadModule = (clientCode: number) => {
    dispatchSetPersistLeadDirectoryData({
      data,
      offset,
      ...scrollHeights,
      searchData,
    });
    history?.push({
      pathname: `/lead-module/lead-directory-list/edit/${clientCode}`,
      state: {
        clientCode,
        multiSelectData,
        sortByLeadReceivedOn,
        sortByStage,
        sortByComment,
        searchData,
        isPersist: true,
        tab: urlSearch,
      },
    });
  };

  const handleHistoryLeadModule = (data: any) => {
    setStoreHistoryData(data);
    setShowHistoryModal(!showHistoryModal);
  };
  const openDrawer = (leadData: any) => {
    if (token) {
      const finalData = {
        token,
        clientCode: leadData?.client_code,
      };
      dispatchGetSingleClientDirectoryLeadDetailsAction(finalData);
    }
    dispatchSetPersistLeadDirectoryData({
      data,
      offset,
      ...scrollHeights,
      searchData,
    });
    setClientCode(leadData?.client_code);
    setSelectedLead(leadData);
    setIsDrawerOpen(true);
    dispatchResetSingleClientLeadDirectoryDetails();
  };
  const closeDrawer = () => {
    setSelectedLead(null);
    setIsDrawerOpen(false);
    setClientCode(null);
  };

  const handleSentEmailToLead = (data: SendEmailPayload) => {
    // setShowIsLeadSendEmail(!showIsLeadSendEmail);
    dispatchResetLeadEmailHistory();
    setShowIsLeadSendEmailData({
      to_email: data?.to_email ? data?.to_email : "",
      client_code: data?.client_code,
    });
    if (data?.to_email) {
      let finalData = {
        email: data?.to_email,
        client_code: data?.client_code,
        template_name: "lead_thank_you_email",
        token,
      };
      dispatchEmailHistoryAction(finalData);
    }
  };
  const handleToggleSentEmailToLead = () => {
    setShowIsLeadSendEmail(!showIsLeadSendEmail);
    setIsEmailError("");
  };

  const handleSendEmail = (data: SendEmailPayload) => {
    if (
      showIsLeadSendEmailData?.to_email &&
      token &&
      showIsLeadSendEmailData?.client_code
    ) {
      let finaData = {
        token,
        to_email: leadEmailText,
        client_code: showIsLeadSendEmailData?.client_code,
      };
      dispatchSentEmailAction(finaData);
    }
    handleToggleSentEmailToLead();
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [leadDirectoryList]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      }
    }

    if (
      success === 1 &&
      message === "Customer lead list has been fetched successfully!"
    ) {
      dispatchResetMessage();
      dispatchResetSuccess();
    } else if (
      success === 1 &&
      message === "Lead thank you mail has been sent successfully."
    ) {
      toast.success("Lead thank you mail has been sent successfully", {
        duration: 2000,
      });
      dispatchResetMessage();
      dispatchResetSuccess();
    } else if (
      success === 1 &&
      message === "Lead Thank You email for this mail has been sent already."
    ) {
      toast.error("Already, Thank You mail has been sent on this email Id", {
        duration: 2000,
      });
      dispatchResetMessage();
      dispatchResetSuccess();
    } else if (commentSuccess === 1) {
      dispatchResetLeadCommentsSuccess();
      toast.success("Comment Added Successfully!!", {
        duration: 2000,
      });
      let finalData: GetLeadModuleCommentsPayload = {
        client_code: leadData?.client_code,
        token,
      };
      dispatchGetLeadModuleCommentsAction(finalData);
      // setOffset(0)
    } else if (leadDirectoryRecordingsSuccess === 1) {
      dispatchResetLeadModuleRecordingsSuccess();
      toast.success("Recording Link Added Successfully!!", {
        duration: 2000,
      });
      let finalData: GetLeadModuleCommentsPayload = {
        client_code: leadData?.client_code,
        token,
      };
      dispatchGetLeadRecordingDetailsAction(finalData);
      // setOffset(0)
    }

    return false;
  };

  const handlePrepareReportData = () => {
    if (token && startDate && endDate) {
      let params: GetLeadDirectoryListPayloadType = {
        token,
        startDate: moment(
          startDate,
          "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (zz)"
        ).format("DD-MM-YYYY"),
        endDate: moment(
          endDate,
          "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (zz)"
        ).format("DD-MM-YYYY"),

        searchData,
        sortByLeadReceivedOn: sortByLeadReceivedOn?.name
          ? sortByLeadReceivedOn
          : persistSortByLeadReceivedOn,
        sortByStage: sortByStage?.name ? sortByStage : persistSortByStage,
        sortByComment: sortByComment?.name
          ? sortByComment
          : persistSortByComment,
        stage: stage?.value ? stage : persistFilterData?.stage,
        leadCategory: leadCategory?.value
          ? leadCategory
          : persistFilterData?.leadCategory,
        leadStatusFilter: leadStatusFilter?.value
          ? leadStatusFilter
          : persistFilterData?.leadStatusFilter,
        callFrequency: callFrequency?.value
          ? callFrequency
          : persistFilterData?.callFrequency,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        leadAssignTo: leadAssignTo?.value
          ? leadAssignTo
          : persistFilterData?.leadAssignTo,
        role:
          loginData?.group_id === 1 || loginData?.group_id === 285
            ? "admin"
            : "user",
        turnOverFilter: turnOverFilter?.value
          ? turnOverFilter
          : persistFilterData?.turnOverFilter,
        migrateToFinacFilter: migrateToFinacFilter
          ? migrateToFinacFilter
          : persistFilterData?.migrateToFinacFilter,

        clientCategory: clientCategoryFilter?.value
          ? clientCategoryFilter
          : persistFilterData?.clientCategoryFilter,
        scopeofWork: scopeFilter?.value
          ? scopeFilter
          : persistFilterData?.scopeFilter,
        city: cityFilter?.value
          ? cityFilter?.value
          : persistFilterData?.cityFilter,
      };
      handleDownloadReport(params);
    }
  };

  const handleDownloadReport = (params: any) => {
    let reportName = `${
      downloadType === "comment"
        ? "Lead_Comments_Report_"
        : "Lead_Stage_Progress_Report_"
    }${params?.startDate}_to_${params?.endDate}.xlsx`;
    if (downloadType === "comment") {
      downloadLeadCommentsReportsApi(params).then((response) => {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
        });
        FileSaver.saveAs(blob, reportName);
        toast.success("Comments Wise Report Downloaded Successfully!", {
          duration: 3000,
        });
      });
    } else {
      downloadLeadStageProgressReportsApi(params).then((response) => {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
        });
        FileSaver.saveAs(blob, reportName);
        toast.success("Stage Wise Report Downloaded Successfully!", {
          duration: 3000,
        });
      });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonHeader title="Lead Directory" />
        </div>
        {isLeadListPresent && (
          <div className="col-md-12 ">
            {/* <div className="col-md-12"> */}
            <div
              style={{
                background: "#d8dee4",
                borderRadius: "5px 5px 0 0",
                padding: "0px 15px 0px 15px",
              }}
            >
              <div
                className="d-flex align-items-center"
                style={{ justifyContent: "space-between" }}
              >
                <div className="d-flex">{renderTabs()}</div>
              </div>
            </div>
            {/* </div> */}
            <div className="jobs-card" style={{ position: "relative" }}>
              <div className="header">
                <div className="left-header">
                  <div className="flex-center" style={{ gap: "5px" }}>
                    <div className="heading">
                      {
                        tabs.find((item: TabsType) => item?.label === activeTab)
                          ?.name
                      }
                    </div>
                    {isLeadModuleStageCountPresent && (
                      <div
                        onClick={() => setIsPieChartVisible(!isPieChartVisible)}
                        className="flex-center show-hide-btn-head"
                        style={{ marginTop: "-17px" }}
                      >
                        {
                          <div
                            className="show-hide-btn"
                            style={
                              isPieChartVisible
                                ? {
                                    border: "1px solid #dd4433",
                                    backgroundColor: "#fff6f5",
                                  }
                                : { border: "1px solid #262a44" }
                            }
                          >
                            <img
                              src={
                                isPieChartVisible
                                  ? analyticsIcon
                                  : analyticsGrey
                              }
                              alt=""
                            />
                            <div
                              style={
                                isPieChartVisible
                                  ? { color: "#dd4433" }
                                  : { color: "#262a44" }
                              }
                            >
                              {isPieChartVisible
                                ? "Hide Summary"
                                : "Open Summary"}
                            </div>
                          </div>
                        }
                      </div>
                    )}
                    <div
                      className="flex-center show-hide-btn-head"
                      style={{ marginTop: "-17px" }}
                    >
                      {
                        <div
                          className="show-hide-btn"
                          style={{
                            color: "#DD4433",
                            border: "1px solid #dd4433",
                          }}
                          onClick={handleRefresh}
                        >
                          Refresh
                        </div>
                      }
                    </div>
                  </div>
                  {!fetching && (
                    <div
                      className="sub-heading"
                      style={{ marginTop: "-22px" }}
                    >{`Total ${
                      totalCount ? totalCount : 0
                    } entries found`}</div>
                  )}
                </div>
                <div className="right-header " style={{ marginRight: "0px" }}>
                  <div className="col-md-8 position-relative ">
                    <span
                      style={{ position: "absolute", top: "8px", left: "25px" }}
                    >
                      <SearchIcon />
                    </span>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search"
                      onChange={handleSearch}
                      style={{ paddingLeft: "35px" }}
                      value={searchData}
                    />
                  </div>
                  <div className="mr-1">
                    <LeadModuleListFilter
                      setToggle={setToggle}
                      loginData={loginData}
                      toggle={toggle}
                      setText={setText}
                      finalUserList={finalUserList}
                      setStageOffset={setStageOffset}
                      setStageText={setStageText}
                      stageLimit={stageLimit}
                      setStatus={setStatus}
                      setFilterStartDate={setFilterStartDate}
                      setFilterEndDate={setFilterEndDate}
                      filterStatus={filterStatus}
                      filterStartDate={filterStartDate}
                      filterEndDate={filterEndDate}
                      multiSelectData={multiSelectData}
                      stage={stage}
                      leadCategory={leadCategory}
                      setLeadCategory={setLeadCategory}
                      callFrequency={callFrequency}
                      fetching={fetching}
                      limit={limit}
                      setCallFrequency={setCallFrequency}
                      setStage={setStage}
                      setOffset={setOffset}
                      leadAssignTo={leadAssignTo}
                      setLeadAssignTo={setLeadAssignTo}
                      handleApplyFilter={handleApplyFilter}
                      handleFilterClear={handleFilterClear}
                      turnOverFilter={turnOverFilter}
                      setTurnOverFilter={setTurnOverFilter}
                      setMigrateToFinacFilter={setMigrateToFinacFilter}
                      migrateTofinacFilter={migrateToFinacFilter}
                      leadStatusFilter={leadStatusFilter}
                      setLeadStatusFilter={setLeadStatusFilter}
                      setClientCategoryFilter={setClientCategoryFilter}
                      clientCategoryFilter={clientCategoryFilter}
                      finalCategoryFilterList={finalCategoryFilterList}
                      handleClientCategoryChange={handleClientCategoryChange}
                      setCategoryOffset={setCategoryOffset}
                      setCategoryText={setCategoryText}
                      history={history}
                      setScopeFilter={setScopeFilter}
                      scopeFilter={scopeFilter}
                      finalScopeFilterList={finalScopeFilterList}
                      handleScopeChange={handleScopeChange}
                      setScopeOffset={setScopeOffset}
                      setScopeText={setScopeText}
                      setCityOffset={setCityOffset}
                      setCitySearchTerm={setCitySearchTerm}
                      cityFilter={cityFilter}
                      cityFetching={cityFetching}
                      finalCityFilterOptions={finalCityFilterOptions}
                      handleCityFilterChange={handleCityFilterChange}
                      stageDropDown={stageDropDown}
                    />
                  </div>
                  <div className="mr-1">
                    <LeadListSorting
                      setToggle={setToggleSort}
                      toggle={toggleSort}
                      selectedData={
                        sortByLeadReceivedOn?.value
                          ? sortByLeadReceivedOn
                          : sortByStage?.value
                          ? sortByStage
                          : sortByComment?.value
                          ? sortByComment
                          : { name: "Recently Added/Modified First", value: "" }
                      }
                      handleSorting={handleSorting}
                    />
                  </div>
                  {isLeadCommentsReportsDownloadPresent &&
                    activeTab !== "priority-lead" && (
                      <div className="mr-2">
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-download-invoice">
                              Download Reports
                            </Tooltip>
                          }
                        >
                          <DownloadCheckInReports
                            startDate={startDate}
                            endDate={endDate}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                            handleDownload={handlePrepareReportData}
                            type="Lead"
                            downloadType={downloadType}
                            setDownloadType={setDownloadType}
                          />
                        </OverlayTrigger>
                      </div>
                    )}
                </div>
              </div>
              {isPieChartVisible && isLeadModuleStageCountPresent && (
                <LeadStageCount leadStageCount={leadStageCount} />
              )}
              {fetching && offset === 0 ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : leadDirectoryList?.length > 0 || data?.length > 0 ? (
                <LeadModuleListTable
                  offset={offset}
                  fetching={fetching}
                  leadDirectoryList={data}
                  handleSetLeadData={handleSetLeadData}
                  handleEditLeadModule={handleEditLeadModule}
                  handleHistoryLeadModule={handleHistoryLeadModule}
                  handleToggleLeadCommentsModal={handleToggleLeadCommentsModal}
                  tableHeader={LEAD_DIRECTORY_LIST_HEADERS.filter(
                    (item: TableHeadersType) => {
                      if (activeTab === "all-leads") {
                        return isLeadStatusPresent
                          ? item.value !== "due_date"
                          : item.value !== "due_date" &&
                              item.value !== "status";
                      }
                      return isLeadStatusPresent || item.value !== "status";
                    }
                  )}
                  isEditClientLeadDetailsPresent={
                    isEditClientLeadDetailsPresent
                  }
                  openDrawer={openDrawer}
                  closeDrawer={closeDrawer}
                  handleToggleSentEmailToLead={handleToggleSentEmailToLead}
                  handleSentEmailToLead={handleSentEmailToLead}
                  handleSendEmail={handleSendEmail}
                  handleChangeLeadStatus={handleChangeLeadStatus}
                  isEmailLeadDetailsPresent={isEmailLeadDetailsPresent}
                />
              ) : (
                fetching === false &&
                leadDirectoryList?.length === 0 && (
                  <div className="mt-5 pb-5">
                    <EmptyListPage
                      title="No Lead List Found!"
                      imageWidth="30%"
                    />
                  </div>
                )
              )}
              {/* {showHistoryModal && (
              <div>
                <LeadModuleStageHistory
                  leadHistory={leadHistory}
                  storeHistoryData={storeHistoryData}
                  setShowHistoryModal={setShowHistoryModal}
                  showHistoryModal={showHistoryModal}
                  fetching={leadFetching}
                />
              </div>
            )} */}
            </div>
          </div>
        )}
        <Toaster />
        {handleErrorModal()}
        {showHistoryModal && (
          <div>
            <LeadModuleStageHistory
              leadHistory={leadHistory}
              storeHistoryData={storeHistoryData}
              setShowHistoryModal={setShowHistoryModal}
              showHistoryModal={showHistoryModal}
              fetching={leadFetching}
            />
          </div>
        )}
        {emailFetching && <Loader />}
        {showLeadCommentsModal && (
          <ProgressCommentsModal
            modal={showLeadCommentsModal}
            toggleModal={handleToggleLeadCommentsModal}
            characterLength={1000}
            data={leadData}
            showLeadCommentsModal={showLeadCommentsModal}
            handlePostComment={handleSubmitLeadComment}
            handleSubmitLeadRecording={handleSubmitLeadRecording}
            commentFetching={commentLeadFetching}
            commentsSuccess={commentSuccess}
            leadDirectoryRecordingsSuccess={leadDirectoryRecordingsSuccess}
            jobProgressCommentsList={leadModuleCommentsList}
            showInputBox
            type={"leadModule"}
            isLeadCommentListPresent={isLeadCommentListPresent}
            leadDirectoryRecordingsList={leadDirectoryRecordingsList}
          />
        )}
        {showIsLeadSendEmail && (
          <LeadModuleEmailModal
            modal={showIsLeadSendEmail}
            toggleModal={handleToggleSentEmailToLead}
            data={leadEmailHistory}
            leadEmailText={leadEmailText}
            setLeadEmailText={setLeadEmailText}
            handleSendEmail={handleSendEmail}
            setShowIsLeadSendEmail={setShowIsLeadSendEmail}
            isEmailError={isEmailError}
            setIsEmailError={setIsEmailError}
          />
        )}

        {showConfirmationModal && (
          <ConfirmationModal
            toggle={() => {
              handleShowConfirmationModal();
            }}
            isOpen={showConfirmationModal}
            title={`${leadStatus?.status ? `Disable Lead?` : `Enable Lead?`}`}
            message={`Are you sure you want to ${
              leadStatus?.status ? `disable this lead` : `enable this lead`
            }?`}
            confirmButtonText={leadStatus?.status ? "Disable" : "Enable"}
            onPressConfirm={() => {
              handleLeadStatusApiCall();
              handleShowConfirmationModal();
            }}
          />
        )}

        {isDrawerOpen && (
          <RightDrawer
            isRight={true}
            isOpen={isDrawerOpen}
            onClose={closeDrawer}
            history={history}
            clientCode={clientCode}
            singleClientleadDirectoryDetails={singleClientleadDirectoryDetails}
            multiSelectData={multiSelectData}
            sortByLeadReceivedOn={sortByLeadReceivedOn}
            sortByStage={sortByStage}
            sortByComment={sortByComment}
            searchData={searchData}
            loginData={loginData}
            fetching={fetching}
            activeTab={activeTab}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  finacUser: state.auth.finacUsersList,
  fetching: state.clientDirectory.fetching,
  leadFetching: state.clientDirectory.leadFetching,
  error: state.clientDirectory.error,
  statusCode: state.clientDirectory.statusCode,
  leadDirectoryList: state.clientDirectory.leadDirectoryList,
  persistLeadDirectoryList: state.clientDirectory.persistLeadDirectoryList,
  totalCount: state.clientDirectory.leadDirectoryTotal,
  success: state.clientDirectory.success,
  message: state.clientDirectory.message,
  loginData: state.auth.loginData,
  sideMenus: state.auth.sideMenus,
  commentLeadFetching: state.clientDirectory.leadDirectoryCommentsFetching,
  commentSuccess: state.clientDirectory.leadDirectoryCommentsSuccess,
  leadDirectoryRecordingsSuccess:
    state.clientDirectory.leadDirectoryRecordingsSuccess,
  leadModuleCommentsList: state.clientDirectory.leadDirectoryCommentsList,
  leadDirectoryRecordingsList:
    state.clientDirectory.leadDirectoryRecordingsList,
  leadHistory: state.clientDirectory.leadHistory,
  leadStageCount: state.clientDirectory.leadStageCount,
  singleClientleadDirectoryDetails:
    state.clientDirectory.singleClientleadDirectoryDetails,
  emailFetching: state.clientDirectory.emailFetching,
  cityFetching: state.clientDirectory.cityFetching,
  leadEmailHistory: state.clientDirectory.leadClientEmailHistory,
  clientCategoryList: state.masterData.clientCategoryList,
  clientCategoryTotalCount: state.masterData.clientCategoryTotalCount,
  scopeOfWorkList: state.masterData.scopeOfWorkList,
  scopeOfWorkTotalCount: state.masterData.scopeOfWorkTotalCount,
  uniqueCityList: state.clientDirectory.uniqueCityList,
  uniqueCityCount: state.clientDirectory.uniqueCityCount,
  leadStageData: state.clientDirectory.leadStageList,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetLeadDirectoryTotal: () => dispatch(resetLeadDirectoryTotal()),
  dispatchResetSingleClientLeadDirectoryDetails: () =>
    dispatch(resetSingleClientLeadDirectoryDetails()),
  dispatchGetLeadListDataAction: (data: GetLeadDirectoryListPayloadType) =>
    dispatch(getClientDirectoryLeadListAction(data)),
  dispatchGetLeadSortByThresholdListDataAction: (
    data: GetLeadDirectoryListPayloadType
  ) => dispatch(getClientDirectorySortByThresholdLeadListAction(data)),
  dispatchGetLeadStageCountAction: (data: GetLeadDirectoryListPayloadType) =>
    dispatch(getClientDirectoryLeadStageCountAction(data)),
  dispatchGetLeadStageSortByStageCountAction: (
    data: GetLeadDirectoryListPayloadType
  ) => dispatch(getClientDirectoryLeadStageSortByStageCountAction(data)),

  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetLeadModuleCommentsAction: (data: GetLeadModuleCommentsPayload) =>
    dispatch(getLeadCommentsDetailsAction(data)),
  dispatchGetLeadRecordingDetailsAction: (data: GetLeadModuleCommentsPayload) =>
    dispatch(getLeadRecordingDetailsAction(data)),
  dispatchAddLeadModuleCommentAction: (data: AddLeadModuleCommentPayload) =>
    dispatch(addLeadCommentsAction(data)),
  dispatchAddLeadRecordingAction: (data: AddLeadModuleCommentPayload) =>
    dispatch(addLeadRecordingAction(data)),
  dispatchResetLeadCommentsListing: () =>
    dispatch(resetLeadModuleCommentsListing()),
  dispatchResetLeadModuleRecordingsListing: () =>
    dispatch(resetLeadModuleRecordingsListing()),
  dispatchResetLeadCommentsSuccess: () =>
    dispatch(resetLeadModuleCommentsSuccess()),
  dispatchResetLeadModuleRecordingsSuccess: () =>
    dispatch(resetLeadModuleRecordingsSuccess()),
  dispatchResetLeadList: () => dispatch(resetLeadDirectoryList()),
  dispatchResetSuccess: () => dispatch(resetClientDirectorySuccess()),
  dispatchResetCommentSuccess: () => dispatch(resetLeadModuleCommentsSuccess()),

  dispatchResetError: () => dispatch(resetClientDirectoryError()),
  dispatchResetMessage: () => dispatch(resetClientDirectoryMessage()),
  dispatchResetStatusCode: () => dispatch(resetClientDirectoryStatusCode()),
  dispatchResetFetching: () => dispatch(resetClientDirectoryFetching()),
  dispatchResetLeadDirectoryCommentsFetching: () =>
    dispatch(resetLeadDirectoryCommentsFetching()),
  dispatchLeadHistory: (data: GetHistoryPayload) =>
    dispatch(leadHistoryAction(data)),
  dispatchResetLeadHistory: () => dispatch(resetLeadHistory()),
  dispatchResetLeadStageCount: () => dispatch(resetLeadStageCount()),
  dispatchSetPersistLeadDirectoryData: (data: any) =>
    dispatch(setPersistLeadDirectory(data)),
  dispatchGetSingleClientDirectoryLeadDetailsAction: (
    data: SingleClientLeadDirectoryDetails
  ) => dispatch(getSingleClientDirectoryLeadDetailsAction(data)),
  dispatchSentEmailAction: (data: SendEmailPayload) =>
    dispatch(leadSentEmailAction(data)),
  dispatchEmailHistoryAction: (data: EmailHistoryPayload) =>
    dispatch(leadClientSentEmailHistoryAction(data)),
  dispatchResetLeadEmailHistory: () => dispatch(resetLeadClientEmailHistory()),
  dispatchResetLeadEmailFetching: () => dispatch(resetLeadEmailFetching()),
  dispatchGetMasterDataClientCategoryAction: (
    data: GetClientCategoryPayloadType
  ) => dispatch(getMasterDataClientCategoryAction(data)),
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataScopeOfWorkAction(data)),
  dispatchGetCityListAction: (data: GetCityListPayloadType) =>
    dispatch(getCityListAction(data)),
  dispatchResetCityListAction: () => dispatch(resetUniqueCityList()),
  dispatchResetCityCountAction: () => dispatch(resetUniqueCityCount()),
  dispatchResetCityFetching: () => dispatch(resetCityFetching()),
  dispatchLeadStatusChangeAction: (data: ChangeClientStatusChangePayloadType) =>
    dispatch(updateLeadStatusAction(data)),
  dispatchLeadStageData: (data: GetCityListPayloadType) =>
    dispatch(getStageListAction(data)),
  dispatchResetLeadStageData: () => dispatch(resetLeadStageList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadModule);
